var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-app-bar', {
    staticClass: "flex-column flex-wrap align-start justify-start px-2 px-sm-6",
    attrs: {
      "fixed": "",
      "height": _vm.headerHeight,
      "app": "",
      "color": "transparent"
    }
  }, [_c('v-app-bar-nav-icon', {
    staticClass: "rounded-sm ml-0",
    on: {
      "click": function ($event) {
        _vm.$store.state.drawer = !_vm.$store.state.drawer;
      }
    }
  }), _c('v-btn', {
    attrs: {
      "icon": "",
      "tile": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$store.commit('openSearch');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-magnify")])], 1), _c('v-spacer'), _vm.unreachableControllers.length > 0 ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-1 rounded-xl",
          attrs: {
            "height": "40",
            "color": _vm.unreachableControllers.length > 0 ? 'error' : 'success'
          },
          on: {
            "click": function ($event) {
              _vm.errorDialog = true;
            }
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" Kontroller hiba ")])];
      }
    }], null, false, 1212912478)
  }, [_c('span', [_vm._v("További információkért lépj tovább")])]) : _vm._e(), _c('error-modal', {
    attrs: {
      "errorDialog": _vm.errorDialog,
      "unreachableControllers": _vm.unreachableControllers
    },
    on: {
      "update:errorDialog": function ($event) {
        _vm.errorDialog = $event;
      },
      "update:error-dialog": function ($event) {
        _vm.errorDialog = $event;
      }
    }
  }), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-1 rounded-sm",
          attrs: {
            "icon": "",
            "height": "40",
            "color": _vm.statusIndicatorColor,
            "to": {
              name: 'Services'
            }
          }
        }, 'v-btn', attrs, false), on), [_vm.services.running !== _vm.services.all && _vm.services.running !== 0 ? [_c('v-icon', {
          attrs: {
            "color": _vm.statusIndicatorColor
          }
        }, [_vm._v("mdi-alert-circle")])] : [_c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("mdi-check-circle")])]], 2)];
      }
    }])
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.statusIndicatorTitle) + " ")])]), _c('v-menu', {
    attrs: {
      "transition": "slide-y-transition",
      "right": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-1 px-1 rounded-sm",
          attrs: {
            "text": "",
            "small": "",
            "height": "40"
          }
        }, 'v-btn', attrs, false), on), [_c('v-avatar', {
          staticClass: "rounded-sm",
          attrs: {
            "color": "grey lighten-4",
            "size": "32"
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "24",
            "color": "grey"
          }
        }, [_vm._v("mdi-account")])], 1), _c('div', {
          staticClass: "data text-left mx-2"
        }, [_c('div', {
          staticClass: "font-weight-bold text-subtitle-2",
          staticStyle: {
            "text-transform": "none"
          }
        }, [_vm._v(" " + _vm._s(_vm.$store.state.user.name) + " ")])]), _c('v-icon', {
          attrs: {
            "size": "24"
          }
        }, [_vm._v("mdi-chevron-down")])], 1)];
      }
    }])
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex pa-2"
  }, [_c('v-avatar', {
    staticClass: "rounded",
    attrs: {
      "color": "grey",
      "size": "64"
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "48",
      "color": "white"
    }
  }, [_vm._v("mdi-account")])], 1), _c('div', {
    staticClass: "d-flex flex-column justify-center pa-2 ml-2"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$store.state.user.name) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.$store.state.user.email) + " ")])])], 1), _c('div', {
    staticClass: "d-flex flex-column justify-center pa-2"
  }, [_c('v-btn', {
    staticClass: "mb-1",
    attrs: {
      "text": "",
      "small": "",
      "block": "",
      "to": "/change-password",
      "height": "36"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-key-variant")]), _vm._v(" Jelszó módosítás ")], 1), _c('v-btn', {
    staticClass: "mb-1",
    attrs: {
      "text": "",
      "small": "",
      "block": "",
      "height": "36"
    },
    on: {
      "click": function ($event) {
        return _vm.$store.commit('toggleDarkMode');
      }
    }
  }, [_vm.$vuetify.theme.dark ? [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-white-balance-sunny")]), _vm._v(" Váltás világos módra ")] : [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-weather-night")]), _vm._v(" Váltás sötét módra ")]], 2)], 1), _c('v-sheet', {
    attrs: {
      "color": "primary",
      "height": "2"
    }
  }), _c('v-sheet', {
    staticClass: "pa-2"
  }, [_vm.$store.state.impersonateId ? _c('v-btn', {
    staticStyle: {
      "white-space": "normal"
    },
    attrs: {
      "text": "",
      "block": ""
    },
    on: {
      "click": _vm.stopImpersonate
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-domino-mask")]), _vm._v(" Megszemélyesítés befejezés ")], 1) : _vm._e(), _c('v-btn', {
    attrs: {
      "text": "",
      "block": ""
    },
    on: {
      "click": _vm.$logout
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-exit-run")]), _vm._v(" Kijelentkezés ")], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5"
  }, [_vm._v(" Új verzió érhető el. ")]), _c('v-card-text', [_vm._v("Amennyiben most az "), _c('b', [_vm._v("\"Elhalasztás\"")]), _vm._v(" lehetőséget választja, később célszerű lesz a "), _c('b', [_vm._v("Ctrl + F5")]), _vm._v(" billentyűkombinációt alkalmazni, hogy a változtatások betöltsenek. Ez a választás befolyásolhatja az oldal működését.")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog = false;
        _vm.reloadPage();
      }
    }
  }, [_vm._v(" Oldal újratöltése ")]), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v(" Elhalasztás ")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }